<template>
  <!-- 右边 -->
  <div class="login-box">
    <!-- 目录 -->
    <div class="login-list">
      <el-tabs
        v-model="mydata.activeName"
        class="demo-tabs"
        @tab-change="tabChange"
      >
        <el-tab-pane label="账号密码登录" name="first">
          <passwordLogin
            v-model:myusername="mydata.form.username"
            v-model:mypassword="mydata.form.password"
          ></passwordLogin>
        </el-tab-pane>
        <!-- 因手机号验证有bug 所以以下需要暂时注释 -->
        <el-tab-pane label="短信验证登录" name="second">
          <phoneNumberLogin
            v-model:myphonenum="mydata.form2.phonenum"
            v-model:myphonecode="mydata.form2.phonecode"
          ></phoneNumberLogin>
        </el-tab-pane>
        <!-- 因手机号验证有bug 所以以下邮箱验证只是暂时使用 -->
        <!-- <el-tab-pane label="邮箱验证登录" name="second">
          <phoneNumberLogin
            v-model:myphonenum="mydata.form2.phonenum"
            v-model:myphonecode="mydata.form2.phonecode"
          ></phoneNumberLogin>
        </el-tab-pane> -->
      </el-tabs>
    </div>

    <!-- 是否已读  -->
    <div class="login-checkbox">
      <el-checkbox v-model="mydata.protocolchecked" size="large">
        <!-- <p class="text"> -->
        我已阅读并同意
        <!-- </p> -->
      </el-checkbox>
      <span @click="agreementClick('user_agreement')" style="cursor: pointer"
        >《用户协议》</span
      >
      <span>和</span>
      <span @click="agreementClick('privacy_agreement')" style="cursor: pointer"
        >《隐私协议》</span
      >
    </div>

    <!-- 忘记密码 -->
    <div class="forgot-password">
      <p @click="retrievePasswordButton">忘记密码</p>
    </div>

    <!-- 按钮 -->
    <el-button type="primary" @click="submit">登录</el-button>
    <el-button @click="loginRegisterButton" class="no-border">注册</el-button>
    <div class="app-box">
      <!-- <img src="@/assets/Ellipse 54.png" alt="" @click="handleWechatLogin" /> -->
      <!-- <div class="line-box"></div> -->
      <!-- <img src="@/assets/Ellipse 55.png" alt="" /> -->
      <!-- <div class="line-box"></div> -->
      <p @click="goBackHome">
        <!-- <el-icon><HomeFilled /></el-icon> -->
        首页
      </p>
    </div>

    <!-- 弹窗(协议) -->
    <el-dialog class="agreement-box" v-model="mydata.dialog" width="343">
      <div>
        <p v-html="mydata.getAgreementObj"></p>
      </div>
    </el-dialog>

     <!-- 弹窗(微信登录) -->
    <el-dialog class="agreement-box" v-model="mydata.wechatDialog" width="500">
      <div style="display:flex;justify-content: center;">
        <div id="login_container" style="width:300px;"></div>
      </div>
    </el-dialog>


  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";

import passwordLogin from "@/views/login/nowLogin/passwordLogin/index.vue";

import phoneNumberLogin from "@/views/login/nowLogin/phoneNumberLogin/index.vue";
// 引入接口
import { login, getAgreement } from "@/api/login/nowLogin/index.js";

import { codeLogin } from "@/api/login/retrievePasswordLogin/index.js";
//验证是否为手机号
import { isPhoneNumber, isEmail } from "@/utils/validate.js";

// 是否为空白字符串
function isWhiteStr(str) {
  let reg = /^\s*$/;
  return reg.test(str);
}

const router = useRouter();

var mydata = reactive({
  wechatDialog:false,
  form: {
    username: "",
    password: "",
  },
  form2: {
    phonenum: "",
    phonecode: "",
  },
  protocolchecked: false, //是否已读
  activeName: "first", //tabs目录：默认显示第一个目录（账号密码登录）

  name: "", //  隐私协议 privacy_agreement      用户协议 user_agreement
  getAgreementObj: {}, //获取协议内容
  dialog: false,
});

//获取协议内容
function agreementClick(val) {
  mydata.name = val;
  getAgreement({ name: mydata.name }).then((res) => {
    // console.log(res);
    mydata.getAgreementObj = res.data;
    mydata.dialog = true;
  });
}

function tabChange(tab) {
  // console.log("这是tabs目录", tab);
  // 重置数据
  mydata.form = {
    username: "",
    password: "",
  };
  mydata.form2 = {
    phonenum: "",
    phonecode: "",
  };
  mydata.protocolchecked = false;
}

// // 微信登录
// const handleWechatLogin = () => {
//   // // 打开弹窗
//   // mydata.wechatDialog = true
//   // nextTick(()=>{
//   //   // 创建二维码
//     // createWechatCode()
//   // })

  
//   // let appid = 'wx02a89637c3850b55'
//   // let redirect_uri = encodeURIComponent('https://www.mobile.tl100.com/#/wechat') // 测试1
//   // let redirect_uri = encodeURIComponent('https://www.tl100.com/#/wechat') // 测试2
//   // let code = new Date().getTime()
//   // 跳转到授权页面
//   // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${code}#wechat_redirect`;



// };

// 【不要修改这些代码】
function handleWechatLogin() {
  let appid = "wx5957032995e4d145";
  let redirect_uri = encodeURIComponent("https://www.tl100.com/#/h5test2");
  let code = new Date().getTime();
  // 跳转到授权页面
  // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${code}#wechat_redirect`;
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${code}#wechat_redirect`;
}
// 【不要修改这些代码】

//登录的事件函数
function submit() {
  // 账号密码登录
  if (mydata.activeName === "first") {
    // 如果没有勾选协议
    if (!mydata.protocolchecked) {
      // 提示弹窗
      ElMessage({
        message: "请在勾选协议后进行注册或登录",
        type: "warning",
      });
      // 终止执行
      return;
    }
    // 如果账号为空
    if (isWhiteStr(mydata.form.username)) {
      // 提示弹窗
      ElMessage({
        message: "账号不得为空",
        type: "warning",
      });
      // 终止执行
      return;
    }
    // 如果密码为空
    if (isWhiteStr(mydata.form.password)) {
      // 提示弹窗
      ElMessage({
        message: "密码不得为空",
        type: "warning",
      });
      // 终止执行
      return;
    }

    // 调用login方法，发送请求
    login({
      account: mydata.form.username,
      password: mydata.form.password,
    }).then((res) => {
      // console.log(res.data, "用户信息");
      // 存储后端返回的用户信息
      localStorage.setItem("userInfo", JSON.stringify(res.data));
      // 提示弹窗
      ElMessage({
        message: "登录成功",
        type: "success",
      });

      // 跳转页面
      if (localStorage.getItem("loginBack")) {
        let { path, query } = getLoginBack();
        router.push({
          path,
          query,
        });
      } else {
        router.push({
          path: "/layout/list/personalCenter",
        });
      }
    });
  }

  // 手机号验证码登录
  if (mydata.activeName === "second") {
    // 如果没有勾选协议
    if (!mydata.protocolchecked) {
      // 提示弹窗
      ElMessage({
        message: "请在勾选协议后进行注册或登录",
        type: "warning",
      });
      // 终止执行
      return;
    }
    // 如果不是手机号，也不是邮箱，那么提醒弹窗并终止代码
    if (
      isPhoneNumber(mydata.form2.phonenum) === false &&
      isEmail(mydata.form2.phonenum) === false
    ) {
      ElMessage({
        message: "手机号/邮箱格式错误",
        type: "warning",
      });
      return;
    }
    // 如果验证码为空
    if (isWhiteStr(mydata.form2.phonecode)) {
      // 提示弹窗
      ElMessage({
        message: "验证码不得为空",
        type: "warning",
      });
      // 终止执行
      return;
    }
    let type = isPhoneNumber(mydata.form2.phonenum) ? "phone" : "email";
    codeLogin({
      type: type,
      account: mydata.form2.phonenum,
      code: mydata.form2.phonecode,
    }).then((res) => {
      // console.log(res.data, "用户信息");
      // 存储后端返回的用户信息
      localStorage.setItem("userInfo", JSON.stringify(res.data));
      // 提示弹窗
      ElMessage({
        message: "登录成功",
        type: "success",
      });

      // 跳转页面
      if (localStorage.getItem("loginBack")) {
        let { path, query } = getLoginBack();
        router.push({
          path,
          query,
        });
      } else {
        router.push({
          path: "/layout/list/personalCenter",
        });
      }
    });
  }
}

function getLoginBack() {
  let fullPath = localStorage.getItem("loginBack");
  let path = fullPath.split("?")[0];
  let query = fullPath.split("?")[1];
  let obj = {};
  // console.log(path);
  // console.log(query);
  if (query) {
    let arr = query.split("&");
    arr.forEach((item) => {
      let arr2 = item.split("=");
      obj[arr2[0]] = arr2[1];
    });
  }
  // console.log(obj);
  return { path, query: obj };
}

//忘记密码点击事件
function retrievePasswordButton() {
  router.push({
    path: "/login/retrievePasswordLogin",
  });
}

//注册点击事件
function loginRegisterButton() {
  router.push({
    path: "/loginRegister",
  });
}

///////////////返回首页
function goBackHome() {
  router.push({
    path: "/layout/list/home",
  });
}

function enterFn(e) {
  if (e.keyCode === 13) {
    submit();
  }
}


// function createWechatCode(){
//     var obj = new WxLogin({
//     self_redirect:false, // false就是不在iframe里面跳转网址，而是整个页面跳转网址
//     id:"login_container", 
//     appid: "wx02a89637c3850b55", 
//     scope: "snsapi_login", 
//     redirect_uri: encodeURIComponent('https://www.tl100.com/#/wechat'),
//     //  state: "",
//     //  style: "",
//     //  href: "",
//     onReady: function(isReady){
//       console.log('isReady',isReady);
//     }
//  });
// }

onMounted(() => {
  window.addEventListener("keydown", enterFn);
});
onBeforeUnmount(() => {
  window.removeEventListener("keydown", enterFn);
});
</script>

<style scoped lang="scss">
//登录盒子
.login-box {
   background-color: #ffffff;
  // border: 1px solid rgb(255, 238, 0);
  border-radius: 8px;
  padding: 0px 16px !important;

  //目录
  .login-list {
    //  width: 296px !important;
    //  margin:0 auto;
    margin-top: 30px;
    // border: 1px solid red;

    ////整体目录list
    :deep(.el-tabs__header.is-top) {
      // margin-bottom: 0px;
      // border: 1px solid rgb(250, 222, 10);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 24px;
    }
    //目录左边箭头
    :deep(.el-tabs__nav-prev) {
      display: none;
    }
    //目录右边箭头
    :deep(.el-tabs__nav-next) {
      display: none;
    }
    //目录宽度
    :deep(.el-tabs__nav-wrap.is-scrollable.is-top) {
      padding: 0px;
    }
    /////整体宽度字的宽度
    :deep(.el-tabs__nav.is-top) {
       // border: 1px solid blue;
      width: 270px !important;
      height: 37px;
      display: flex;
      justify-content: space-between !important;
      align-items: center;
      // border:1px solid rgb(38, 0, 255);
    }
    //////每个字体
    :deep(.el-tabs__item.is-top) {
      width: 120px;
      text-align: center;
      padding: 0px;
      font-size: 16px;
      font-weight: 400;
      color: #282828;
      // border: 1px solid green;
      padding-bottom: 13px;
      // margin:0 auto;
      // color:#333333;
    }
    :deep(.el-tabs__nav.is-top) {
      > div:nth-of-type(2) {
        //width: 150px;
      }
    }
    :deep(.el-tabs__item.is-top:hover) {
      color: #009de0;
    }

    // 目录的内容
    :deep(.demo-tabs > .el-tabs__content) {
      // width: 916px;
      // height:200px;
      // border: 1px solid red;
      background-color: #ffffff;
      // border-radius: 8px;
      margin: 0px;
    }
  }

  //已读勾选框
  :deep(.login-checkbox) {
    height: 40px;
    display: flex;
    align-items: center;

    > span {
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      color: #009de0;
    }
    > span:nth-of-type(2) {
      color: #606266;
    }
  }

  //忘记密码
  .forgot-password {
    height: 20px;
    position: relative;
    // border: 1px solid red;
    margin-bottom: 5px;
    cursor: pointer;
    > p {
      font-size: 12px;
      line-height: 20px;
      color: #009de0;
      position: absolute;
      right: 0px;
    }
  }

  //////微信与qq
  .app-box {
    // width: 74px;
    height: 27px;
    margin: 0 auto;
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    // border: 1px solid red;
    > img {
      // margin-right: 20px;
      cursor: pointer;
    }
    > p {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      // :deep(.el-icon) {
      //   font-size: 25px;
      // }
      cursor: pointer;
    }
    > p:hover {
      color: #009de0;

      text-shadow: 1px 0px 1px #009de092;
    }
    .line-box {
      width: 1px;
      height: 18px;
      background-color: #dbdbdb;
      margin: 0px 10px;
    }
  }
}

/////////////////两个按钮
:deep(.el-button) {
  width: 311px;
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 4px;
  // margin-bottom: 10px;
  cursor: pointer;
}

//两个按钮一起用会有margin-left:12px;
:deep(.el-button + .el-button) {
  margin-left: 0px;
}

:deep(.el-button.el-button--primary) {
}

:deep(.el-button.no-border){
   border:none;
}

////////弹窗（协议）
:deep(.el-dialog.agreement-box) {
  min-height: 500px;
}

//弹窗
:deep(.el-dialog) {
  border-radius: 8px;
}
</style>
